
import { HeadlinePathSegment } from '@/models/headline-path-segment';
import he from 'he';
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'HeadlinePathSegmentView',
  props: {
    segment: {
      type: Object as PropType<HeadlinePathSegment>,
      required: true,
      default: null
    }
  },
  setup() {
    /**
     * Decodes an HTML string that contains escaped sequences
     * @param input
     */
    function decodeHtmlString(input: string): string {
      return he.decode(input);
    }

    return {
      decodeHtmlString
    };
  }
});
